import { RootState } from "@/modules/common";

export const selectRawPrice = (state: RootState) =>
  state.basket.basket?.rawPrice;
